import {
	getCookie,
	getStoredValue,
	removeCookie,
	setCookie,
	setStoredValue,
} from "@workspace/shared/utils/storage";

import { TENANT_COOKIE_KEY, TENANT_STORAGE_KEY } from "./types";

export function getStoredTenant(): string | null {
	return getStoredValue(TENANT_STORAGE_KEY);
}

export function setStoredTenant(tenant: string | null): void {
	setStoredValue(TENANT_STORAGE_KEY, tenant);
}

export function getCookieTenant(): string | null {
	return getCookie(TENANT_COOKIE_KEY);
}

export function setCookieTenant(tenant: string | null): void {
	if (tenant) {
		setCookie(TENANT_COOKIE_KEY, tenant);
	} else {
		removeCookie(TENANT_COOKIE_KEY);
	}
}
